import React from 'react'
import PropTypes from 'prop-types'
import {
    AspectRatio,
    Box,
    Skeleton as ChakraSkeleton,
    Stack,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

const PricingAndPromotionsSkeleton = ({singleLine = false}) => {
    const styles = useMultiStyleConfig('ProductTile')
    return (
        <Stack {...styles.skeletonStack} data-testid="sf-product-tile-pricing-and-promotions-skeleton">
            <ChakraSkeleton
                {...styles.skeletonLinePrimary}
                {...(singleLine ? {height: '20px'} : {})}
            />
            {!singleLine && <ChakraSkeleton {...styles.skeletonLineSecondary} />}
        </Stack>
    )
}

PricingAndPromotionsSkeleton.propTypes = {
    singleLine: PropTypes.bool
}

const ProductTileSkeleton = () => {
    const styles = useMultiStyleConfig('ProductTile')
    return (
        <Box data-testid="sf-product-tile-skeleton">
            <Stack {...styles.skeletonContainer}>
                <Box {...styles.imageWrapper}>
                    <AspectRatio ratio={1} {...styles.image}>
                        <ChakraSkeleton />
                    </AspectRatio>
                </Box>
                <PricingAndPromotionsSkeleton />
            </Stack>
        </Box>
    )
}

export {PricingAndPromotionsSkeleton, ProductTileSkeleton}
